<template>
  <div class="home wrapper">
    <div class="row">
      <div class="col">
        <RecipesList>Latest brews</RecipesList>
      </div>
    </div>
  </div>
</template>

<script>
  import RecipesList from "../components/RecipesList.vue";

  export default {
    name: "home",
    components: {
      RecipesList,
    },
    data() {
      return {
        errors: null,
        loading: false,
        searchText: '',
        recipes: [],
        params: {},
        filters: {
          recipeTypes: [
            { field: 'allGrain',    name: 'All Grain' },
            { field: 'extract',     name: 'Extract' },
            { field: 'partialMash', name: 'Partial Mash' }
          ],
          recipeCategories: [
            { field: 'ale',   name: "Ale" },
            { field: 'lager', name: "Lager" }
          ]
        }
      };
    },
  };
</script>

<style scoped lang="scss">

</style>
